// export const app_url = '/landingpage/zithas-driving/'
// Live 
// export const app_url = '/insolvency-practitioners'

// ztpl 
export const app_url = '/construction'
// mars.ztpl.net
// api.zithas.com
// https://mars.ztpl.net/api/retrieveAccessToken

